var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DFDFDF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -28) translate(80 28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.852,
    cy: 1.843,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.607,
    cy: 1.843,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.363,
    cy: 1.843,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.119,
    cy: 1.843,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.852,
    cy: 10.837,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.607,
    cy: 10.837,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.363,
    cy: 10.837,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.119,
    cy: 10.837,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.852,
    cy: 19.832,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.607,
    cy: 19.832,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.363,
    cy: 19.832,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.119,
    cy: 19.832,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.852,
    cy: 28.827,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.607,
    cy: 28.827,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.363,
    cy: 28.827,
    rx: 1.729,
    ry: 1.755
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.119,
    cy: 28.827,
    rx: 1.729,
    ry: 1.755
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.4fa834f65690d891b4b168845b277442.svg";
export { ForwardRef as ReactComponent };